export const context = {
  default() {
    return this.$parent
  }
}
export default {
  context
}
